import { Card, CardBody, Col } from "reactstrap";
import { Image } from "src/AbstractElements";
import { dynamicImage } from "src/Service";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import CommonCardHeader from "../../../../CommonElements/CommonCardHeader/CommonCardHeader";
import { withControlData, withControlDataList } from "../../../../Data/BonusUi/Carousel/Carousel";
import { WithControl } from "../../../../utils/Constant";

const WithControls = () => {
  return (
    <Col xl="6" xs="12">
      <Card>
        <CommonCardHeader title={WithControl} span={withControlData} />
        <CardBody>
          <Swiper navigation={true} modules={[Navigation]}>
            {withControlDataList.map((item, index) => (
              <SwiperSlide key={index}>
                <Image src={dynamicImage(item.image)} alt="drawing-room" className="d-block w-100" />
              </SwiperSlide>
            ))}
          </Swiper>
        </CardBody>
      </Card>
    </Col>
  );
};

export default WithControls;
